<template>
    <div class="input-field"        
        @click="handleFocus"
    >
        <textarea class="form-control"
            :class="{ error }"
            :value="value"
            @input="$emit('input', $event.target.value)"
            @keyup="handleKeyup"
            v-focus="focus"
            @focus="handleFocus"
            @blur="handleBlur"
            v-autosize
            ref="textarea"
        ></textarea>
        <label :class="{active, error}"
            @click="$refs.input.focus()"><span class="text-red-500" v-if="required">*</span> {{ placeholder }}</label>
        <div class="text-red-500 text-sm"
            v-if="error"
            v-html="error"></div>
        <div class="mt-1 text-sm text-gray-600"
            v-if="helpText"
            v-html="helpText"></div>
    </div>
</template>
<script>
    import isEmpty from 'lodash/isEmpty';
    export default {
        props: {
            value: '',
            placeholder: {
                type: String,
                default: ''
            },
            focus: {
                type: Boolean,
                default: false
            },
            required: {
                type: Boolean,
                default: false,
            },
            error: {
                type: String,
                default: ''
            },
            helpText: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                active: false
            }
        },
        watch: {
            value() {
                this.$refs.textarea.focus()
            }
        },
        mounted() {
            if (!isEmpty(this.value)) {
                this.active = true
            }
        },
        methods: {
            handleKeyup() {
                this.$emit('updated')
            },
            handleFocus() {
                this.active = true
                this.$refs.textarea.focus();
            },
            handleBlur() {
                if (!this.value) {
                    this.active = false
                }
            }
        }
    }
</script>
<style lang="scss"
    scoped>
    textarea {
        line-height: normal !important;
        overflow-y: hidden;
        padding: .8rem 0 .8rem 0 !important;
        resize: none;
        -webkit-box-sizing: border-box !important;
        box-sizing: border-box !important;
        height: 45px;
    }
    .error {
        @apply text-red-500;
        font-size: .875rem;            
    }
    .help-text {
        @apply text-gray-500;
        font-size: .875rem;
        margin-top: 0.25rem;
    }
</style>